// Import our custom CSS
import './styles.scss';
import 'bootstrap/js/dist/modal.js';
import init from './init.js';

init();
